import { DragOverlay } from "@dnd-kit/core";
import { StyledListItem } from "../SongList/SongList.style";
import SongListItem from "../SongList/SongListItem";
import type ColormapInterface from "shared-types/colormapinterface";
import type { Song } from "src/@types/api-types";
import { useSelector } from "react-redux";
import { favoritePlaylistSelector } from "@redux/session/selectors";

interface Props {
	colors: ColormapInterface;
	song: Song | null;
	activeDragItem: boolean;
}

const DragSongOverlay = ({ colors, song }: Props) => {
	const favoritePlaylist = useSelector(favoritePlaylistSelector);
	const favoriteSongsIds = favoritePlaylist?.playlistSongs?.map(({ song }) => song.id) || [];
	return (
		<DragOverlay zIndex={1}>
			{song && (
				<StyledListItem colors={colors} selected>
					<SongListItem index={0} song={song} isLiked={favoriteSongsIds.includes(song.id)} />
				</StyledListItem>
			)}
		</DragOverlay>
	)
};
export default DragSongOverlay;
